import { combineReducers } from 'redux';
import diffusion from './diffusion';
import edito from './edito';
import images from './images';
import { INITIAL_DATA_LOAD_SUCCESS } from 'news/actions';

const isFetched = (state = false, action) => {
  switch (action.type) {
    case INITIAL_DATA_LOAD_SUCCESS:
      return true;
    default:
      return state;
  }
};

export default combineReducers({
  isFetched,
  diffusion,
  edito,
  images,
});

export const getIsFetched = state => state.isFetched;



// WEBPACK FOOTER //
// ./src/modules/news/reducers/index.js